// export default Business;
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Loading } from "./Loading";

function Business() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [receive,setReceive]=useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

   

  useEffect(() => {
    async function fetchBusinessData() {
      try {
        const response = await fetch(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/businessdata`);
        // Log response to debug
        console.log("API Raw Response -------- :", response);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        } 
        const data = await response.json(); // This handles the parsing automatically
        console.log(data);
        const events = JSON.parse(data);
        console.log("API Response--------:", events);
        setReceive(true);
        setData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching business data:", error);
      }
    }
    fetchBusinessData();
  }, []);

  // Auto-rotate through stats/images
  useEffect(() => {
    if (!data?.stats?.length) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === data.stats.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [receive]);

  if (!data) {
    return (
      <div>
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-h-auto">
      {/* Hero Section */}
      <div className="flex flex-col md:flex-row items-center justify-between px-6 py-1 max-w-7xl mx-auto">
        {/* Left Content */}
        <div className="md:w-1/2 mb-8 md:mb-0">
          <span className="text-indigo-400 text-sm uppercase tracking-widest">
            {t(data.header.topText)}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mt-2 mb-4">
            {t(data.header.title)}
          </h1>
          <p className="text-lg mb-6">{t(data.header.description)}</p>
          <Link to="/learning-hub-plus">
            <button className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 transition text-white font-semibold rounded-lg">
              {t(data.header.ctaText)}
            </button>
          </Link>
        </div>

        {/* Right Content */}
        <div className="md:w-1/2 relative text-center">
          {/* Image from the current stat */}
          <img
            src={data.stats[currentImageIndex]?.carouselImages || "/placeholder.svg"}
            alt={t(data.stats[currentImageIndex]?.text)}
            className="w-full rounded-lg shadow-lg transition-all duration-700"
          />

          {/* Stat Number & Text */}
          <div className="w-full mt-6 transition-all duration-500">
            <div className="text-2xl font-bold">
              {t(data.stats[currentImageIndex]?.number)}
            </div>
            <div className="text-sm">
              {t(data.stats[currentImageIndex]?.text)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Business;


